/**
 * <s-referral-capture> — Remembers a refer-a-friend link and tags the cart
 * Reads `?ref=` from the URL, keeps it in localStorage, and saves it as the
 * "Referred by" cart attribute so it appears on the order in Shopify admin.
 *
 * Attributes:
 *   cart-update-url — routes.cart_update_url from Liquid
 *   current-ref     — the cart's existing "Referred by" value, if any
 *   customer-id     — the signed-in customer's id, to ignore self-referrals
 */
class SReferralCapture extends HTMLElement {
  static #KEY = 'rg-referral';

  connectedCallback() {
    const fromUrl = new URLSearchParams(window.location.search).get('ref');
    const cleanRef = fromUrl && /^\d{4,20}$/.test(fromUrl) ? fromUrl : null;
    if (cleanRef) {
      try {
        localStorage.setItem(SReferralCapture.#KEY, cleanRef);
      } catch (e) {
        // Storage can be blocked; the cart attribute below still records this visit.
      }
    }

    let ref = cleanRef;
    if (!ref) {
      try {
        ref = localStorage.getItem(SReferralCapture.#KEY);
      } catch (e) {
        ref = null;
      }
    }
    if (!ref) return;
    if (ref === this.getAttribute('customer-id')) return;
    if (ref === this.getAttribute('current-ref')) return;

    const url = this.getAttribute('cart-update-url');
    if (!url) return;

    // The .js suffix returns JSON instead of redirecting to the cart page.
    fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Referred by': ref } }),
    }).catch(() => {});
  }
}

if (!customElements.get('s-referral-capture')) {
  customElements.define('s-referral-capture', SReferralCapture);
}
